import React, { useCallback, useRef, FC } from 'react';
import clsx from 'classnames';
import { useDetectOutsideClick } from 'global/index';
import { DropdownProps } from 'common/dropdown/dropdown.type';

import styles from './dropdown.module.scss';

export const Dropdown: FC<DropdownProps> = props => {
  const { align, children, disabled, items, onSelectItem } = props;
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const onClick = () => setIsActive(!isActive);

  const selectItem = useCallback(
    (item, index) => {
      onSelectItem?.(item, index);
      setIsActive(false);
    },
    [setIsActive, onSelectItem],
  );

  return (
    <div className={props.className}>
      <div className={styles.menuContainer} ref={dropdownRef}>
        <button className={clsx(styles.menuTrigger, { [styles.disabled]: disabled })} type="button" onClick={onClick}>
          {children}
        </button>
        <nav
          className={clsx(styles.menu, { [styles.active]: isActive }, align === 'left' ? styles.left : styles.right)}>
          {!disabled && (
            <ul>
              {items?.map((item: any, index: number) => (
                <li className={clsx({ [styles.disabled]: item.disabled })} key={item.id}>
                  <a onClick={() => !item.disabled && selectItem(item, index)}>{item.label}</a>
                </li>
              ))}
            </ul>
          )}
        </nav>
      </div>
    </div>
  );
};

Dropdown.defaultProps = {
  align: 'right',
  disabled: false,
  items: [],
  onSelectItem: () => {},
} as any;
